webpackJsonp([1],{

/***/ "+Q1Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contentful = __webpack_require__("mRK8");

exports.default = (0, _contentful.createClient)({
  space: 'yiht275v448t',
  accessToken: '249df7651fc18730ddb65c0e83c0eac73bd7c4827dbf26a332cce57fdcd25f7f',
  resolveLinks: false
});

/***/ }),

/***/ "+vr4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (response) {
  var items = {};
  var entries = getPropertValue(response, 'entries');
  var assets = getPropertValue(response, 'assets');

  if (!Array.isArray(entries)) {
    // eslint-disable-next-line
    console.warn(entries);
    throw new Error('Unexpected response');
  }

  entries.forEach(function (item) {
    var id = getPropertValue(item, 'sys.id');
    var itemObject = { id: id };
    itemObject = addUniqueProperty(item, 'sys.createdAt', itemObject, 'createdAt');
    itemObject = addUniqueProperty(item, 'sys.updatedAt', itemObject, 'updatedAt');
    itemObject = addUniqueProperty(item, 'sys.contentType.sys.id', itemObject, 'contentType');
    itemObject = mergeFields(item, itemObject);
    items[id] = itemObject;
  });

  if (!Array.isArray(assets)) {
    // eslint-disable-next-line
    console.warn(assets);
    throw new Error('Unexpected response', response);
  }

  assets.forEach(function (item) {
    var id = getPropertValue(item, 'sys.id');
    var itemObject = { id: id };
    itemObject = addUniqueProperty(item, 'sys.createdAt', itemObject, 'createdAt');
    itemObject = addUniqueProperty(item, 'sys.updatedAt', itemObject, 'updatedAt');
    itemObject = addUniqueProperty(item, 'fields.file.en-GB.contentType', itemObject, 'contentType');
    itemObject = mergeFields(item, itemObject, true);
    items[id] = itemObject;
  });

  return items;
};

function getPropertValue(originalObject, property) {
  if ((typeof originalObject === 'undefined' ? 'undefined' : _typeof(originalObject)) !== 'object') {
    // eslint-disable-next-line
    console.warn(originalObject);
    throw new Error('Unexpected response', originalObject);
  }

  var props = property.split('.');

  var currentProp = Object.assign({}, originalObject);

  props.forEach(function (prop) {
    if (currentProp[prop] === undefined) {
      // eslint-disable-next-line
      console.warn(currentProp, prop);
      throw new Error('Unexpected response');
    }

    currentProp = currentProp[prop];
  });

  return currentProp;
}

function addUniqueProperty(source, sourceProp, result, resultProp) {
  if (result[resultProp] !== undefined) {
    // eslint-disable-next-line
    console.warn(result[resultProp], result, resultProp);
    throw new Error('Unexpected response, prop already exists', result, resultProp);
  }

  var sourceValue = getPropertValue(source, sourceProp);
  var response = Object.assign({}, result);
  response[resultProp] = sourceValue;
  return response;
}

function mergeFields(item, currentObject, asset) {
  var itemObject = Object.assign({}, currentObject);
  var fields = getPropertValue(item, 'fields');

  Object.keys(fields).forEach(function (field) {
    var value = getPropertValue(fields[field], 'en-GB');

    if (!asset) {
      if (Array.isArray(value)) {
        var newArray = [];

        value.forEach(function (arrayItem) {
          newArray.push(getPropertValue(arrayItem, 'sys.id'));
        });

        value = newArray;
      } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = getPropertValue(value, 'sys.id');
      }
    }

    if (itemObject[field] !== undefined) {
      // eslint-disable-next-line
      console.warn(itemObject, field, value);
      throw new Error('Unexpected response, prop already exists');
    }

    itemObject[field] = value;
  });

  return itemObject;
}

/***/ }),

/***/ "/0Zp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Link = __webpack_require__("rkxl");

var _Image = __webpack_require__("mbeB");

var _Image2 = _interopRequireDefault(_Image);

var _MultiLineText = __webpack_require__("tQID");

var _MultiLineText2 = _interopRequireDefault(_MultiLineText);

var _ProfileBanner = __webpack_require__("IOVQ");

var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileBanner = function ProfileBanner(_ref) {
  var image = _ref.image,
      description = _ref.description,
      buttonLink = _ref.buttonLink,
      buttonText = _ref.buttonText,
      maxWidth = _ref.maxWidth;

  var button = void 0;

  if (buttonLink && buttonText) {
    var domain = 'https://indiajackson.co.uk/';

    if (buttonLink.includes(domain)) {
      var url = buttonLink.replace(domain, '/');
      button = _react2.default.createElement(
        _Link.Link,
        { style: _ProfileBanner2.default.link, to: url },
        buttonText
      );
    } else {
      button = _react2.default.createElement(
        'a',
        { style: _ProfileBanner2.default.link, href: buttonLink },
        buttonText
      );
    }
  }

  return _react2.default.createElement(
    'section',
    { style: _ProfileBanner2.default.container },
    _react2.default.createElement(
      'div',
      { style: _extends({}, _ProfileBanner2.default.wrapper, { maxWidth: maxWidth }) },
      _react2.default.createElement(
        'div',
        { style: _ProfileBanner2.default.image },
        _react2.default.createElement(_Item2.default, { asset: true, element: _Image2.default, itemId: image, width: 200, height: 200 })
      ),
      _react2.default.createElement(
        'div',
        { style: _ProfileBanner2.default.textWrapper },
        _react2.default.createElement(_MultiLineText2.default, {
          style: _ProfileBanner2.default.paragraph,
          text: description,
          lastStyle: _ProfileBanner2.default.paragraphLast
        }),
        button
      )
    )
  );
};

ProfileBanner.propTypes = {
  image: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired,
  buttonLink: _propTypes2.default.string,
  buttonText: _propTypes2.default.string,
  maxWidth: _propTypes2.default.number
};

ProfileBanner.defaultProps = {
  buttonLink: null,
  buttonText: 'Click me',
  maxWidth: _ProfileBanner2.default.wrapperMaxWidth
};

exports.default = (0, _radium2.default)(ProfileBanner);

/***/ }),

/***/ "/AFp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FourOhFour = __webpack_require__("AaBd");

var _FourOhFour2 = _interopRequireDefault(_FourOhFour);

var _SiteNav = __webpack_require__("rUZv");

var _SiteNav2 = _interopRequireDefault(_SiteNav);

var _ProfileBanner = __webpack_require__("/0Zp");

var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);

var _ProjectGrid = __webpack_require__("eRyt");

var _ProjectGrid2 = _interopRequireDefault(_ProjectGrid);

var _Project = __webpack_require__("D9nf");

var _Project2 = _interopRequireDefault(_Project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  siteNav: _SiteNav2.default,
  fourOhFourComponent: _FourOhFour2.default,
  profileBanner: _ProfileBanner2.default,
  projectGrid: _ProjectGrid2.default,
  singleProjectComponent: _Project2.default
};

/***/ }),

/***/ "24bY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _FourOhFourDefault = __webpack_require__("Sn9y");

var _FourOhFourDefault2 = _interopRequireDefault(_FourOhFourDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FourOhFourDefault = function (_Component) {
  _inherits(FourOhFourDefault, _Component);

  function FourOhFourDefault(props) {
    _classCallCheck(this, FourOhFourDefault);

    var _this = _possibleConstructorReturn(this, (FourOhFourDefault.__proto__ || Object.getPrototypeOf(FourOhFourDefault)).call(this, props));

    _this.state = { count: 15 };
    return _this;
  }

  _createClass(FourOhFourDefault, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var interval = setInterval(function () {
        if (_this2.state.count <= 0) {
          clearInterval(interval);
          window.location.reload();
        } else {
          _this2.setState({ count: _this2.state.count - 1 });
        }
      }, 1100);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: _FourOhFourDefault2.default.wrapper },
        _react2.default.createElement(
          'h1',
          { style: _FourOhFourDefault2.default.heading },
          'Error loading website!'
        ),
        _react2.default.createElement(
          'p',
          { style: _FourOhFourDefault2.default.text },
          'So sorry, but I could not load right now. Trying again in:'
        ),
        _react2.default.createElement(
          'span',
          { style: _FourOhFourDefault2.default.count },
          this.state.count
        )
      );
    }
  }]);

  return FourOhFourDefault;
}(_react.Component);

exports.default = FourOhFourDefault;

/***/ }),

/***/ "2DsD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_SIZE = undefined;

var _colours = __webpack_require__("y62H");

var _spacing = __webpack_require__("dkrt");

var ICON_SIZE = exports.ICON_SIZE = 25;

exports.default = {
  container: {
    backgroundColor: _colours.GREY_LIGHT,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: _colours.GREY_LIGHT_HIGHLIGHT
  },

  hoverFix: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },

  wrapper: {
    maxWidth: _spacing.SITE_WIDTH,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    flexDirection: 'column'
  },

  navItems: {
    display: 'flex',
    width: '100%'
  },

  navContent: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    position: 'relative'
  },

  logo: {
    width: 350,
    marginBottom: 20
  },

  iconLinks: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    listStyle: 'none',
    margin: '0 0 0 ' + ICON_SIZE + 'px',
    padding: 0,
    justifyContent: 'center'
  },

  links: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'absolute',
    left: 0,
    right: 0,
    backgroundColor: _colours.WHITE,
    borderColor: _colours.GREY_LIGHT_HIGHLIGHT,
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderWidth: 2,
    zIndex: 2
  },

  iconLink: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    margin: '0 20px'
  },

  menuButton: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    appearance: 'none',
    background: 'none',
    border: 0,
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    position: 'relative',
    ':focus': {
      outline: 'none'
    }
  },

  buttonColour: _colours.BLACK,
  buttonColourHover: _colours.TURQOISE,

  hidden: {
    opacity: 0
  }
};

/***/ }),

/***/ "2HMY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollToTop = function (_Component) {
  _inherits(ScrollToTop, _Component);

  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);

    return _possibleConstructorReturn(this, (ScrollToTop.__proto__ || Object.getPrototypeOf(ScrollToTop)).apply(this, arguments));
  }

  _createClass(ScrollToTop, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(_react.Component);

ScrollToTop.propTypes = {
  // eslint-disable-next-line
  location: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]).isRequired
};

exports.default = (0, _reactRouterDom.withRouter)(ScrollToTop);

/***/ }),

/***/ "4Vwr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  // eslint-disable-next-line
  module.exports = __webpack_require__("K8UX");
} else {
  // eslint-disable-next-line
  module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ "78at":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_SPACING = undefined;

var _colours = __webpack_require__("y62H");

var _spacing = __webpack_require__("dkrt");

var VERTICAL_SPACING = exports.VERTICAL_SPACING = 70;

exports.default = {
  container: {
    backgroundColor: _colours.GREY_LIGHT,
    borderBottomStyle: 'solid',
    borderTopStyle: 'solid',
    borderWidth: 1,
    borderColor: _colours.GREY_LIGHT_HIGHLIGHT
  },

  wrapper: {
    maxWidth: _spacing.SITE_WIDTH,
    margin: '0 auto',
    display: 'flex',
    padding: VERTICAL_SPACING + 'px 10px 0 10px',
    listStyle: 'none',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  }
};

/***/ }),

/***/ "7jFK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CONTENTFUL_SUCCESS':
      {
        var fourOhFour = state;

        Object.keys(payload).forEach(function (id) {
          var _payload$id = payload[id],
              contentType = _payload$id.contentType,
              uuid = _payload$id.uuid;


          if (contentType === 'pageTemplate' && uuid === '404') {
            fourOhFour = id;
          }
        });

        return fourOhFour;
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "ABDP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Image = __webpack_require__("mbeB");

var _Image2 = _interopRequireDefault(_Image);

var _Project = __webpack_require__("cYhV");

var _Project2 = _interopRequireDefault(_Project);

var _WindowResize = __webpack_require__("Zc8V");

var _WindowResize2 = _interopRequireDefault(_WindowResize);

var _MultiLineText = __webpack_require__("tQID");

var _MultiLineText2 = _interopRequireDefault(_MultiLineText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project(props) {
    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));

    _this.state = { width: window.innerWidth };
    _this.onWindowResize = _this.onWindowResize.bind(_this);
    return _this;
  }

  _createClass(Project, [{
    key: 'onWindowResize',
    value: function onWindowResize(width) {
      this.setState({ width: width });
    }
  }, {
    key: 'render',
    value: function render() {
      var i = 1;
      var descriptionStyle = _Project2.default.description;

      switch (this.props.descriptionAlignment) {
        case 'Left':
          descriptionStyle.textAlign = 'left';
          break;
        case 'Right':
          descriptionStyle.textAlign = 'right';
          break;
        default:
          descriptionStyle.textAlign = 'center';
          break;
      }

      return _react2.default.createElement(
        _WindowResize2.default,
        { onWindowResize: this.onWindowResize },
        _react2.default.createElement(
          'section',
          { style: _Project2.default.container },
          _react2.default.createElement(
            'header',
            { style: _Project2.default.header },
            _react2.default.createElement(
              'div',
              { style: _Project2.default.headerWrap },
              _react2.default.createElement(
                'h1',
                { style: _Project2.default.heading },
                this.props.title
              ),
              this.props.description && _react2.default.createElement(_MultiLineText2.default, {
                style: descriptionStyle,
                text: this.props.description
              })
            )
          ),
          _react2.default.createElement(
            'ul',
            { style: _Project2.default.images },
            this.props.images.map(function (id) {
              i += 1;

              return _react2.default.createElement(
                'li',
                { key: i + '-' + id, style: _Project2.default.image },
                _react2.default.createElement(
                  'div',
                  { style: _Project2.default.imageWrapper },
                  _react2.default.createElement(_Item2.default, {
                    element: _Image2.default,
                    itemId: id,
                    width: 1000
                  })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return Project;
}(_react.Component);

Project.propTypes = {
  description: _propTypes2.default.string,
  descriptionAlignment: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  images: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

Project.defaultProps = {
  description: null,
  descriptionAlignment: null
};

exports.default = Project;

/***/ }),

/***/ "AVKS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CONTENTFUL_SUCCESS':
      {
        var typeFields = {};

        Object.keys(payload).forEach(function (id) {
          var _payload$id = payload[id],
              contentType = _payload$id.contentType,
              varContentType = _payload$id.varContentType,
              varEntryField = _payload$id.varEntryField;


          if (contentType === 'route') {
            if (varContentType && varEntryField) {
              if (!typeFields[varContentType]) {
                typeFields[varContentType] = [];
              }

              typeFields[varContentType].push(varEntryField);
            }
          }
        });

        var routeData = {};

        Object.keys(payload).forEach(function (id) {
          var item = payload[id];
          var contentType = item.contentType;

          if (typeFields[contentType]) {
            typeFields[contentType].forEach(function (field) {
              if (!routeData[contentType]) {
                routeData[contentType] = {};
              }

              if (!routeData[contentType][field]) {
                routeData[contentType][field] = {};
              }

              var entryField = item[field];

              routeData[contentType][field][entryField] = id;
            });
          }
        });

        return routeData;
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "AaBd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _FourOhFour = __webpack_require__("bO5E");

var _FourOhFour2 = _interopRequireDefault(_FourOhFour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var text = 'Woops, I couldn\'t find a page here :(';

var FourOhFour = function FourOhFour() {
  return _react2.default.createElement(
    'div',
    { style: _FourOhFour2.default.wrapper },
    _react2.default.createElement(
      'h1',
      { style: _FourOhFour2.default.heading },
      '404'
    ),
    _react2.default.createElement(
      'p',
      { style: _FourOhFour2.default.text },
      text
    )
  );
};

exports.default = FourOhFour;

/***/ }),

/***/ "AupC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return function (dispatch) {
    _contentfulClient2.default.sync({ initial: true }).then(function (response) {
      var success = true;
      var payload = void 0;

      try {
        payload = (0, _transformApiResponse2.default)(response);
      } catch (err) {
        // eslint-disable-next-line
        console.warn(err);
        success = false;
      }

      if (success) {
        dispatch({
          type: 'CONTENTFUL_SUCCESS',
          payload: payload
        });
      } else {
        dispatch({
          type: 'CONTENTFUL_ERROR'
        });
      }
    })
    // eslint-disable-next-line
    .catch(function (err) {
      // eslint-disable-next-line
      console.warn(err);

      dispatch({
        type: 'CONTENTFUL_ERROR',
        payload: err
      });
    });
  };
};

var _contentfulClient = __webpack_require__("+Q1Z");

var _contentfulClient2 = _interopRequireDefault(_contentfulClient);

var _transformApiResponse = __webpack_require__("+vr4");

var _transformApiResponse2 = _interopRequireDefault(_transformApiResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "ChGC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("2KeS");

var _items = __webpack_require__("Kr9q");

var _items2 = _interopRequireDefault(_items);

var _routes = __webpack_require__("e/TB");

var _routes2 = _interopRequireDefault(_routes);

var _routeData = __webpack_require__("AVKS");

var _routeData2 = _interopRequireDefault(_routeData);

var _fourOhFour = __webpack_require__("7jFK");

var _fourOhFour2 = _interopRequireDefault(_fourOhFour);

var _loading = __webpack_require__("jX3G");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  items: _items2.default,
  routes: _routes2.default,
  routeData: _routeData2.default,
  fourOhFour: _fourOhFour2.default,
  loading: _loading2.default
});

/***/ }),

/***/ "D9nf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Project = __webpack_require__("ABDP");

var _Project2 = _interopRequireDefault(_Project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectContainer = function ProjectContainer(_ref) {
  var templateDataItem = _ref.templateDataItem;
  return _react2.default.createElement(_Item2.default, { element: _Project2.default, itemId: templateDataItem });
};

exports.default = ProjectContainer;

/***/ }),

/***/ "G4iQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  image: {
    height: 'auto',
    maxWidth: '100%',
    display: 'block'
  }
};

/***/ }),

/***/ "IOVQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colours = __webpack_require__("y62H");

var _text = __webpack_require__("akZV");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mediaQuery = '@media (max-width: 450px)';

exports.default = {
  container: {
    backgroundColor: _colours.WHITE
  },

  wrapperMaxWidth: 600,

  wrapper: _defineProperty({
    margin: '0 auto',
    display: 'flex',
    padding: '50px 10px'
  }, mediaQuery, {
    flexDirection: 'column',
    alignItems: 'center'
  }),

  image: {
    flex: 1,
    display: 'flex',
    alignItems: 'center'
  },

  textWrapper: _defineProperty({
    flex: 2,
    paddingLeft: 40,
    display: 'flex',
    alignItems: 'center'
  }, mediaQuery, {
    paddingLeft: 0,
    marginTop: 40
  }),

  paragraph: _extends({}, _text.TEXT, {
    fontSize: 20,
    margin: '0 0 14px 0'
  }),

  paragraphLast: {
    margin: 0
  },

  link: _extends({
    marginTop: 20,
    display: 'inline-block',
    padding: '10px 20px',
    background: _colours.GREY_LIGHT,
    borderColor: _colours.GREY_LIGHT_HIGHLIGHT,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5
  }, _text.TEXT, {
    ':hover': {
      textDecoration: 'underline',
      background: _colours.GREY_LIGHT_HIGHLIGHT
    }
  })
};

/***/ }),

/***/ "K8UX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__("2KeS");

var _reduxThunk = __webpack_require__("4ufr");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__("ChGC");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(preloadedState) {
  return (0, _redux.createStore)(_reducers2.default, preloadedState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
}

/***/ }),

/***/ "Kr9q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CONTENTFUL_SUCCESS':
      {
        return payload;
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "MKU2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (route) {
  return route.includes('{{') && route.includes('}}');
};

/***/ }),

/***/ "MrRj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _reactRouterDom = __webpack_require__("F8kA");

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Image = __webpack_require__("mbeB");

var _Image2 = _interopRequireDefault(_Image);

var _Icon = __webpack_require__("QTcA");

var _Icon2 = _interopRequireDefault(_Icon);

var _IconLink = __webpack_require__("SzlO");

var _IconLink2 = _interopRequireDefault(_IconLink);

var _SiteNavTextLink = __webpack_require__("Z/O2");

var _SiteNavTextLink2 = _interopRequireDefault(_SiteNavTextLink);

var _SiteNav = __webpack_require__("2DsD");

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteNav = function (_Component) {
  _inherits(SiteNav, _Component);

  function SiteNav(props) {
    _classCallCheck(this, SiteNav);

    var _this = _possibleConstructorReturn(this, (SiteNav.__proto__ || Object.getPrototypeOf(SiteNav)).call(this, props));

    _this.state = { hover: false };
    _this.hover = _this.hover.bind(_this);
    return _this;
  }

  _createClass(SiteNav, [{
    key: 'hover',
    value: function hover(_hover) {
      if (_hover !== this.state.hover) {
        this.setState({ hover: _hover });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var menuIcon = this.props.menuIcon;

      if (this.props.showSubMenu) {
        menuIcon = this.props.menuCloseIcon;
      }

      var buttonStyle = _SiteNav2.default.menuButton;
      var buttonColour = _SiteNav2.default.buttonColour;

      if (this.state.hover) {
        buttonStyle = _extends({}, buttonStyle, _SiteNav2.default.menuButtonHover);
        buttonColour = _SiteNav2.default.buttonColourHover;
      }

      return _react2.default.createElement(
        'nav',
        { style: _SiteNav2.default.container },
        _react2.default.createElement(
          'div',
          { style: _SiteNav2.default.wrapper },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { style: _SiteNav2.default.logo, to: '/' },
            _react2.default.createElement(_Item2.default, {
              element: _Image2.default,
              itemId: this.props.logo,
              width: 350
            })
          ),
          _react2.default.createElement(
            'div',
            { style: _SiteNav2.default.navItems },
            _react2.default.createElement(
              'div',
              { style: _SiteNav2.default.navContent },
              _react2.default.createElement(
                'ul',
                { style: _SiteNav2.default.iconLinks },
                this.props.iconLinks.map(function (id) {
                  return _react2.default.createElement(
                    'li',
                    { style: _SiteNav2.default.iconLink, key: id },
                    _react2.default.createElement(_Item2.default, {
                      element: _IconLink2.default,
                      itemId: id,
                      height: _SiteNav.ICON_SIZE,
                      width: _SiteNav.ICON_SIZE
                    })
                  );
                })
              )
            ),
            _react2.default.createElement(
              'button',
              {
                style: buttonStyle,
                onClick: this.props.menuClick,
                onMouseOver: function onMouseOver() {
                  return _this2.hover(true);
                },
                onMouseOut: function onMouseOut() {
                  return _this2.hover(false);
                }
              },
              _react2.default.createElement('div', { style: _SiteNav2.default.hoverFix }),
              _react2.default.createElement(_Item2.default, {
                element: _Icon2.default,
                itemId: menuIcon,
                colour: buttonColour,
                height: _SiteNav.ICON_SIZE,
                width: _SiteNav.ICON_SIZE
              })
            )
          )
        ),
        this.props.showSubMenu && _react2.default.createElement(
          'ul',
          { style: _SiteNav2.default.links },
          this.props.links.map(function (id) {
            return _react2.default.createElement(
              'li',
              { style: _SiteNav2.default.link, key: id },
              _react2.default.createElement(_Item2.default, {
                element: _SiteNavTextLink2.default,
                itemId: id
              })
            );
          })
        )
      );
    }
  }]);

  return SiteNav;
}(_react.Component);

SiteNav.propTypes = {
  menuClick: _propTypes2.default.func.isRequired,
  showSubMenu: _propTypes2.default.bool.isRequired,
  menuIcon: _propTypes2.default.string.isRequired,
  menuCloseIcon: _propTypes2.default.string.isRequired,
  logo: _propTypes2.default.string.isRequired,
  iconLinks: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  links: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = (0, _radium2.default)(SiteNav);

/***/ }),

/***/ "QJdw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colours = __webpack_require__("y62H");

exports.default = {
  iconColour: _colours.BLACK
};

/***/ }),

/***/ "QJei":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _Link = __webpack_require__("rkxl");

var _Link2 = _interopRequireDefault(_Link);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Image = __webpack_require__("mbeB");

var _Image2 = _interopRequireDefault(_Image);

var _ProjectGridItem = __webpack_require__("c8xu");

var _ProjectGridItem2 = _interopRequireDefault(_ProjectGridItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectGridItem = function ProjectGridItem(_ref) {
  var url = _ref.url,
      featureImage = _ref.featureImage,
      title = _ref.title;
  return _react2.default.createElement(
    'li',
    { style: _ProjectGridItem2.default.container },
    _react2.default.createElement(
      _Link2.default,
      { key: 'ProjectGridItem-link-' + url, to: '/' + url, style: _ProjectGridItem2.default.link },
      _react2.default.createElement(
        'div',
        { style: _ProjectGridItem2.default.image },
        _react2.default.createElement(_Item2.default, { element: _Image2.default, itemId: featureImage, width: 500, height: 500 })
      ),
      _react2.default.createElement(
        'h2',
        { key: 'ProjectGridItem-h2-' + url, style: _ProjectGridItem2.default.title },
        title
      )
    )
  );
};

ProjectGridItem.propTypes = {
  url: _propTypes2.default.string.isRequired,
  featureImage: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired
};

exports.default = (0, _radium2.default)(ProjectGridItem);

/***/ }),

/***/ "QTcA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _radium = __webpack_require__("Extj");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = __webpack_require__("QJdw");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/no-danger: 0 */

var id = 0;

var Icon = function Icon(_ref) {
  var svg = _ref.svg,
      colour = _ref.colour,
      height = _ref.height,
      width = _ref.width;

  id += 1;
  var className = 'svg-' + id;
  var string = svg.replace(new RegExp(/{{colour}}/, 'g'), colour);

  if (height) {
    string = string.replace(new RegExp(/<svg/, 'g'), '<svg height="' + height + '"');
  }

  if (width) {
    string = string.replace(new RegExp(/<svg/, 'g'), '<svg width="' + width + '"');
  }

  string = string.replace(new RegExp(/<svg/, 'g'), '<svg class="' + className + '"');

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_radium.Style, {
      scopeSelector: '.' + className,
      rules: {
        height: height,
        width: width
      }
    }),
    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: string } })
  );
};

Icon.propTypes = {
  svg: _propTypes2.default.string.isRequired,
  colour: _propTypes2.default.string,
  height: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired
};

Icon.defaultProps = {
  colour: _Icon2.default.iconColour
};

exports.default = Icon;

/***/ }),

/***/ "SkOG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (match, routes, fourOhFour, routeData) {
  var route = (0, _matchRoute2.default)(routes, match.url, fourOhFour);
  var templateId = void 0;
  var templateDataItem = void 0;
  var noTemplateDataItem = false;

  if (route) {
    templateId = route.template;

    if (route.match && route.entryField && route.contentType) {
      templateDataItem = (0, _getRouteDataItem2.default)(routeData, route.contentType, route.entryField, route.match);

      if (templateDataItem === null) {
        noTemplateDataItem = true;
      }
    } else {
      templateDataItem = null;
    }
  } else {
    templateId = null;
    templateDataItem = null;
  }

  return { templateId: templateId, templateDataItem: templateDataItem, noTemplateDataItem: noTemplateDataItem };
};

var _matchRoute = __webpack_require__("zf7l");

var _matchRoute2 = _interopRequireDefault(_matchRoute);

var _getRouteDataItem = __webpack_require__("aET1");

var _getRouteDataItem2 = _interopRequireDefault(_getRouteDataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "Sn9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _text = __webpack_require__("akZV");

exports.default = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100vh'
  },

  heading: _extends({}, _text.TEXT, {
    fontSize: 50
  }),

  text: _extends({}, _text.TEXT, {
    fontSize: 20
  }),

  count: _extends({}, _text.TEXT, {
    fontSize: 30
  })
};

/***/ }),

/***/ "SzlO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _Icon = __webpack_require__("QTcA");

var _Icon2 = _interopRequireDefault(_Icon);

var _IconLink = __webpack_require__("bSg+");

var _IconLink2 = _interopRequireDefault(_IconLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconLink = function (_Component) {
  _inherits(IconLink, _Component);

  function IconLink(props) {
    _classCallCheck(this, IconLink);

    var _this = _possibleConstructorReturn(this, (IconLink.__proto__ || Object.getPrototypeOf(IconLink)).call(this, props));

    _this.state = { hover: false };
    _this.hover = _this.hover.bind(_this);
    return _this;
  }

  _createClass(IconLink, [{
    key: 'hover',
    value: function hover(_hover) {
      if (_hover !== this.state.hover) {
        this.setState({ hover: _hover });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var iconLinkStyle = _IconLink2.default.iconLink;
      var colour = _IconLink2.default.iconLinkColour;

      if (this.state.hover) {
        iconLinkStyle = _extends({}, iconLinkStyle, _IconLink2.default.iconLinkHover);
        colour = _IconLink2.default.iconLinkColourHover;
      }

      return _react2.default.createElement(
        'a',
        {
          href: this.props.url,
          onMouseOver: function onMouseOver() {
            return _this2.hover(true);
          },
          onMouseOut: function onMouseOut() {
            return _this2.hover(false);
          },
          style: iconLinkStyle
        },
        _react2.default.createElement('div', { style: _IconLink2.default.hoverFix }),
        _react2.default.createElement(_Item2.default, {
          element: _Icon2.default,
          itemId: this.props.icon,
          colour: colour,
          height: this.props.height,
          width: this.props.width
        })
      );
    }
  }]);

  return IconLink;
}(_react.Component);

IconLink.propTypes = {
  url: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired
};

exports.default = IconLink;

/***/ }),

/***/ "TqB6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__("rkxl");

var _Link2 = _interopRequireDefault(_Link);

var _SiteNavTextLink = __webpack_require__("YRHV");

var _SiteNavTextLink2 = _interopRequireDefault(_SiteNavTextLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteNavTextLink = function SiteNavTextLink(_ref) {
  var url = _ref.url,
      title = _ref.title,
      active = _ref.active;

  if (active) {
    return _react2.default.createElement(
      'span',
      { style: _SiteNavTextLink2.default.active },
      title
    );
  }

  return _react2.default.createElement(
    _Link2.default,
    { to: '/' + url, style: _SiteNavTextLink2.default.link },
    title
  );
};

SiteNavTextLink.propTypes = {
  url: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  active: _propTypes2.default.bool.isRequired
};

exports.default = (0, _radium2.default)(SiteNavTextLink);

/***/ }),

/***/ "UNex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _FourOhFourDefault = __webpack_require__("24bY");

var _FourOhFourDefault2 = _interopRequireDefault(_FourOhFourDefault);

var _removeLoading = __webpack_require__("y6Z8");

var _removeLoading2 = _interopRequireDefault(_removeLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mounted = false;

var Template = function Template(_ref) {
  var noItem = _ref.noItem,
      components = _ref.components,
      loading = _ref.loading,
      templateDataItem = _ref.templateDataItem;

  if (noItem) {
    if (loading) {
      return null;
    }

    if (mounted === false) {
      mounted = true;
      (0, _removeLoading2.default)();
    }

    return _react2.default.createElement(_FourOhFourDefault2.default, null);
  }

  if (mounted === false) {
    mounted = true;
    (0, _removeLoading2.default)();
  }

  if (!components) {
    return null;
  }

  var i = 0;

  return _react2.default.createElement(
    'div',
    null,
    components.map(function (id) {
      i += 0;

      var key = i + '-' + id;

      return _react2.default.createElement(_Item2.default, {
        key: key,
        itemId: id,
        templateDataItem: templateDataItem
      });
    })
  );
};

Template.propTypes = {
  noItem: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  templateDataItem: _propTypes2.default.string,
  components: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Template.defaultProps = {
  noItem: false,
  fields: null,
  loading: false,
  templateDataItem: null,
  components: null
};

exports.default = Template;

/***/ }),

/***/ "YRHV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _text = __webpack_require__("akZV");

var _colours = __webpack_require__("y62H");

var fontSize = 16;

exports.default = {
  link: _extends({}, _text.LINK, {
    fontSize: fontSize,
    display: 'block',
    padding: 10,
    textAlign: 'center'
  }),

  active: _extends({}, _text.TEXT, {
    fontSize: fontSize,
    color: _colours.TURQOISE,
    display: 'block',
    padding: 10,
    textAlign: 'center'
  })
};

/***/ }),

/***/ "Z/O2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SiteNavTextLink = __webpack_require__("TqB6");

var _SiteNavTextLink2 = _interopRequireDefault(_SiteNavTextLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteNavTextLinkContainer = function (_Component) {
  _inherits(SiteNavTextLinkContainer, _Component);

  function SiteNavTextLinkContainer() {
    _classCallCheck(this, SiteNavTextLinkContainer);

    return _possibleConstructorReturn(this, (SiteNavTextLinkContainer.__proto__ || Object.getPrototypeOf(SiteNavTextLinkContainer)).apply(this, arguments));
  }

  _createClass(SiteNavTextLinkContainer, [{
    key: 'render',
    value: function render() {
      var active = false;

      if (this.props.location.pathname === '/' + this.props.url) {
        active = true;
      }

      return _react2.default.createElement(_SiteNavTextLink2.default, {
        url: this.props.url,
        title: this.props.title,
        active: active
      });
    }
  }]);

  return SiteNavTextLinkContainer;
}(_react.Component);

SiteNavTextLinkContainer.propTypes = {
  url: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRouterDom.withRouter)(SiteNavTextLinkContainer);

/***/ }),

/***/ "ZJzP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepEqual = __webpack_require__("hlyO");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _typeComponentMap = __webpack_require__("/AFp");

var _typeComponentMap2 = _interopRequireDefault(_typeComponentMap);

var _getProps = __webpack_require__("ccDq");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item(props) {
    _classCallCheck(this, Item);

    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

    _this.state = (0, _getProps.getProps)(props);
    return _this;
  }

  _createClass(Item, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState((0, _getProps.getProps)(nextProps));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var props = (0, _getProps.getProps)(nextProps);

      if (!(0, _deepEqual2.default)(this.state, props)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      // Put all this in state and be smarter at processing
      // this, so don't do it during render
      var itemProps = (0, _getProps.getItemProps)(this.props.items, this.props.itemId);
      var passedProps = (0, _getProps.getPassedProps)(this.props);

      var Element = void 0;

      if (this.props.element) {
        Element = this.props.element;
      } else if (itemProps.contentType) {
        if (_typeComponentMap2.default[itemProps.contentType]) {
          Element = _typeComponentMap2.default[itemProps.contentType];
        } else {
          // eslint-disable-next-line
          console.warn('No component map for', itemProps.contentType);
          return null;
        }
      } else {
        // eslint-disable-next-line
        console.warn('Could not get an element for this item');
        return null;
      }

      return _react2.default.createElement(Element, _extends({}, itemProps, passedProps));
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  // eslint-disable-next-line
  element: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  // eslint-disable-next-line
  items: _propTypes2.default.object.isRequired,
  itemId: _propTypes2.default.string
};

Item.defaultProps = {
  element: null,
  itemId: null
};

function mapStateToProps(_ref) {
  var items = _ref.items,
      assets = _ref.assets;

  return { items: items, assets: assets };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Item);

/***/ }),

/***/ "Zc8V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function windowResized(stateHeight, stateWidth) {
  if (stateWidth !== window.innerWidth) {
    return true;
  }

  if (stateHeight !== window.innerHeight) {
    return true;
  }

  return false;
}

var WindowResize = function (_React$Component) {
  _inherits(WindowResize, _React$Component);

  function WindowResize(props) {
    _classCallCheck(this, WindowResize);

    var _this = _possibleConstructorReturn(this, (WindowResize.__proto__ || Object.getPrototypeOf(WindowResize)).call(this, props));

    _this.state = { height: window.innerHeight, width: window.innerWidth };
    _this.updateDimensions = _this.updateDimensions.bind(_this);
    return _this;
  }

  _createClass(WindowResize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);

      if (this.props.runOnMount) {
        this.props.onWindowResize(this.state.width, this.state.height);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      if (windowResized(this.state.height, this.state.width)) {
        this.props.onWindowResize(this.state.width, this.state.height);
      }

      this.setState({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return WindowResize;
}(_react2.default.Component);

WindowResize.propTypes = {
  children: _propTypes2.default.element.isRequired,
  onWindowResize: _propTypes2.default.func.isRequired,
  runOnMount: _propTypes2.default.bool
};

WindowResize.defaultProps = {
  runOnMount: true
};

exports.default = WindowResize;

/***/ }),

/***/ "aET1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (routeData, contentType, entryField, match) {
  if (!routeData) {
    return null;
  }

  if (Object.keys(routeData).length === 0) {
    return null;
  }

  if (!contentType) {
    return null;
  }

  if (!entryField) {
    return null;
  }

  if (!match) {
    return null;
  }

  if (!routeData[contentType]) {
    return null;
  }

  if (!routeData[contentType][entryField]) {
    return null;
  }

  if (!routeData[contentType][entryField][match]) {
    return null;
  }

  return routeData[contentType][entryField][match];
};

/***/ }),

/***/ "akZV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK = exports.TEXT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colours = __webpack_require__("y62H");

var TEXT = exports.TEXT = {
  fontSize: 12,
  lineHeight: 1.5,
  color: _colours.BLACK,
  fontFamily: '\'Josefin Sans\', helvetica, sans-serif',
  fontWeight: 300,
  textDecoration: 'none'
};

var LINK = exports.LINK = _extends({}, TEXT, {
  color: _colours.BLACK,
  cursor: 'pointer',
  ':hover': {
    textDecoration: 'underline',
    color: _colours.TURQOISE
  }
});

/***/ }),

/***/ "bO5E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _text = __webpack_require__("akZV");

var spacing = 80;

exports.default = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing + 'px 0'
  },

  heading: _extends({}, _text.TEXT, {
    margin: 0,
    fontSize: 100,
    fontWeight: 800
  }),

  text: _extends({}, _text.TEXT, {
    fontSize: 20,
    marginTop: spacing
  })
};

/***/ }),

/***/ "bSg+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colours = __webpack_require__("y62H");

exports.default = {
  iconLink: {
    display: 'block',
    position: 'relative'
  },

  hoverFix: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },

  iconLinkColour: _colours.BLACK,
  iconLinkColourHover: _colours.TURQOISE
};

/***/ }),

/***/ "c8xu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ProjectGrid = __webpack_require__("78at");

var _text = __webpack_require__("akZV");

exports.default = {
  container: {
    width: 'calc(33.333% - 20px)',
    marginBottom: _ProjectGrid.VERTICAL_SPACING,
    '@media (max-width: 740px)': {
      width: 'calc(50% - 20px)'
    },

    '@media (max-width: 450px)': {
      width: '100%'
    }
  },

  link: {
    textDecoration: 'none',
    cursor: 'pointer'
  },

  image: {
    ':hover': {
      opacity: 0.5
    }
  },

  title: _extends({}, _text.LINK, {
    fontSize: 22,
    textAlign: 'center',
    fontWeight: 400
  })
};

/***/ }),

/***/ "cYhV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colours = __webpack_require__("y62H");

var _text = __webpack_require__("akZV");

var imageWidth = 600;

exports.default = {
  container: {
    backgroundColor: _colours.WHITE,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: _colours.GREY_LIGHT_HIGHLIGHT
  },

  imageWrapper: {
    maxWidth: imageWidth,
    margin: '0 auto'
  },

  header: {
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: _colours.WHITE
  },

  headerWrap: {
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '60px 0',
    maxWidth: imageWidth,
    margin: '0 auto',
    textAlign: 'center'
  },

  heading: _extends({}, _text.TEXT, {
    margin: 0,
    fontSize: 40,
    fontWeight: 600
  }),

  description: _extends({}, _text.TEXT, {
    fontSize: 20,
    margin: '30px 0 0 0',
    width: '100%',
    padding: '0 10px',
    boxSizing: 'border-box'
  }),

  images: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },

  image: {
    backgroundColor: _colours.WHITE,
    marginBottom: 20
  }
};

/***/ }),

/***/ "ccDq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getItemProps = getItemProps;
exports.getPassedProps = getPassedProps;
exports.getProps = getProps;
function getItemProps(items, itemId) {
  if (!items[itemId]) {
    return { noItem: true };
  }

  return items[itemId];
}

function getPassedProps(props) {
  var passedProps = Object.assign({}, props);
  delete passedProps.itemId;
  delete passedProps.items;
  delete passedProps.assets;
  delete passedProps.element;
  delete passedProps.dispatch;

  if (passedProps.asset !== undefined) {
    delete passedProps.asset;
  }

  return passedProps;
}

function getProps(props) {
  return _extends({}, getItemProps(props.items, props.itemId), getPassedProps(props));
}

/***/ }),

/***/ "dkrt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SITE_WIDTH = exports.SITE_WIDTH = 960;

/***/ }),

/***/ "e/TB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CONTENTFUL_SUCCESS':
      {
        var stateRoutes = [];

        Object.keys(payload).forEach(function (id) {
          var _payload$id = payload[id],
              contentType = _payload$id.contentType,
              uuid = _payload$id.uuid,
              routes = _payload$id.routes;


          if (contentType === 'routes' && uuid === 'Routes - Live') {
            routes.forEach(function (routeId) {
              var route = payload[routeId];

              var data = {
                route: route.regex,
                template: route.template
              };

              if (route.varContentType) {
                data.contentType = route.varContentType;
              }

              if (route.varEntryField) {
                data.entryField = route.varEntryField;
              }

              stateRoutes.push(data);
            });
          }
        });

        return stateRoutes;
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "eRyt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _ProjectGridItem = __webpack_require__("QJei");

var _ProjectGridItem2 = _interopRequireDefault(_ProjectGridItem);

var _ProjectGrid = __webpack_require__("78at");

var _ProjectGrid2 = _interopRequireDefault(_ProjectGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectGrid = function ProjectGrid(_ref) {
  var projects = _ref.projects;
  return _react2.default.createElement(
    'section',
    { style: _ProjectGrid2.default.container },
    _react2.default.createElement(
      'ul',
      { style: _ProjectGrid2.default.wrapper },
      projects.map(function (id) {
        return _react2.default.createElement(_Item2.default, {
          key: id,
          element: _ProjectGridItem2.default,
          itemId: id
        });
      })
    )
  );
};

ProjectGrid.propTypes = {
  projects: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = ProjectGrid;

/***/ }),

/***/ "jX3G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case 'CONTENTFUL_SUCCESS':
    case 'CONTENTFUL_ERROR':
      {
        return false;
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "jYr2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("j1ja");

var _reactRedux = __webpack_require__("RH2O");

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _radium = __webpack_require__("Extj");

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__("F8kA");

var _Routes = __webpack_require__("osXf");

var _Routes2 = _interopRequireDefault(_Routes);

var _configureStore = __webpack_require__("4Vwr");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _ScrollToTop = __webpack_require__("2HMY");

var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)({});

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(
    _radium.StyleRoot,
    null,
    _react2.default.createElement(
      _reactRouterDom.BrowserRouter,
      null,
      _react2.default.createElement(
        _ScrollToTop2.default,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { path: '*', component: _Routes2.default })
      )
    )
  )
), document.querySelector('#app'));

/***/ }),

/***/ "mbeB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = __webpack_require__("G4iQ");

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(_ref) {
  var file = _ref.file,
      title = _ref.title,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      fill = _ref.fill,
      stretchWidth = _ref.stretchWidth,
      contentType = _ref.contentType,
      noItem = _ref.noItem;

  if (noItem) {
    return null;
  }

  var imageHeight = file.details.image.height;
  var imageWidth = file.details.image.width;

  var fillText = '';

  if (fill) {
    fillText = '&fit=fill';
  }

  var ratio = imageHeight / imageWidth;
  var changeSize = true;

  if (height && width) {
    imageHeight = height;
    imageWidth = width;
  } else if (height && !width) {
    imageHeight = height;
    imageWidth = Math.floor(imageHeight / ratio);
    fillText = '&fit=fill';
  } else if (!height && width) {
    imageWidth = width;
    imageHeight = Math.floor(ratio * imageWidth);
    fillText = 'fit=fill';
  } else {
    changeSize = false;
  }

  var jpg = '';

  if (contentType === 'image/jpeg') {
    jpg = 'fm=jpg&fl=progressive';
  }

  var url = void 0;

  if (changeSize) {
    url = file.url + '?w=' + imageWidth + '&h=' + imageHeight + '&' + fillText + '&' + jpg;
  } else {
    url = file.url + '?' + jpg;
  }

  var imageStyles = _Image2.default.image;

  if (stretchWidth) {
    imageStyles = _extends({}, imageStyles, { width: stretchWidth });
  }

  return _react2.default.createElement('img', {
    style: imageStyles,
    width: imageWidth,
    height: imageHeight,
    src: url,
    className: className,
    alt: title
  });
};

Image.propTypes = {
  file: _propTypes2.default.shape({
    url: _propTypes2.default.string,
    details: _propTypes2.default.shape({
      image: _propTypes2.default.shape({
        height: _propTypes2.default.number,
        width: _propTypes2.default.number
      })
    })
  }).isRequired,
  className: _propTypes2.default.string,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  fill: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  stretchWidth: _propTypes2.default.number,
  contentType: _propTypes2.default.string.isRequired,
  noItem: _propTypes2.default.bool
};

Image.defaultProps = {
  className: null,
  width: null,
  height: null,
  fill: true,
  title: 'Content editor has not supplied alt text',
  stretchWidth: null,
  noItem: false
};

exports.default = Image;

/***/ }),

/***/ "osXf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Template = __webpack_require__("UNex");

var _Template2 = _interopRequireDefault(_Template);

var _Item = __webpack_require__("ZJzP");

var _Item2 = _interopRequireDefault(_Item);

var _getProjects = __webpack_require__("AupC");

var _getProjects2 = _interopRequireDefault(_getProjects);

var _getTemplateInfo = __webpack_require__("SkOG");

var _getTemplateInfo2 = _interopRequireDefault(_getTemplateInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoutesContainer = function (_Component) {
  _inherits(RoutesContainer, _Component);

  function RoutesContainer(props) {
    _classCallCheck(this, RoutesContainer);

    var _this = _possibleConstructorReturn(this, (RoutesContainer.__proto__ || Object.getPrototypeOf(RoutesContainer)).call(this, props));

    var match = props.match,
        routes = props.routes,
        fourOhFour = props.fourOhFour,
        routeData = props.routeData;

    _this.state = (0, _getTemplateInfo2.default)(match, routes, fourOhFour, routeData);
    return _this;
  }

  _createClass(RoutesContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _getProjects2.default)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var match = _ref.match,
          routes = _ref.routes,
          fourOhFour = _ref.fourOhFour,
          routeData = _ref.routeData;

      this.setState(_extends({}, (0, _getTemplateInfo2.default)(match, routes, fourOhFour, routeData)));
    }
  }, {
    key: 'render',
    value: function render() {
      var template = this.state.templateId;

      if (this.state.noTemplateDataItem) {
        template = this.props.fourOhFour;
      }

      return _react2.default.createElement(_Item2.default, {
        element: _Template2.default,
        itemId: template,
        templateDataItem: this.state.templateDataItem,
        loading: this.props.loading
      });
    }
  }]);

  return RoutesContainer;
}(_react.Component);

RoutesContainer.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  match: _propTypes2.default.shape({
    url: _propTypes2.default.string
  }).isRequired,
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    route: _propTypes2.default.string,
    template: _propTypes2.default.string
  })).isRequired,
  fourOhFour: _propTypes2.default.string,
  // eslint-disable-next-line
  routeData: _propTypes2.default.object.isRequired
};

RoutesContainer.defaultProps = {
  fourOhFour: null
};

function mapStateToProps(_ref2) {
  var routes = _ref2.routes,
      routeData = _ref2.routeData,
      fourOhFour = _ref2.fourOhFour,
      loading = _ref2.loading;

  return { routes: routes, routeData: routeData, fourOhFour: fourOhFour, loading: loading };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(RoutesContainer));

/***/ }),

/***/ "qSi4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (route, repalce) {
  return route.replace(/{{.*}}/, repalce);
};

/***/ }),

/***/ "rUZv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SiteNav = __webpack_require__("MrRj");

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteNavContainer = function (_Component) {
  _inherits(SiteNavContainer, _Component);

  function SiteNavContainer(props) {
    _classCallCheck(this, SiteNavContainer);

    var _this = _possibleConstructorReturn(this, (SiteNavContainer.__proto__ || Object.getPrototypeOf(SiteNavContainer)).call(this, props));

    _this.state = { showSubMenu: false };

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(SiteNavContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.location !== nextProps.location) {
        this.setState({ showSubMenu: false });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.setState({ showSubMenu: !this.state.showSubMenu });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_SiteNav2.default, {
        menuClick: this.onClick,
        showSubMenu: this.state.showSubMenu,
        menuIcon: this.props.menuIcon,
        menuCloseIcon: this.props.menuCloseIcon,
        logo: this.props.logo,
        iconLinks: this.props.iconLinks,
        links: this.props.links
      });
    }
  }]);

  return SiteNavContainer;
}(_react.Component);

SiteNavContainer.propTypes = {
  // eslint-disable-next-line
  location: _propTypes2.default.object.isRequired,
  menuIcon: _propTypes2.default.string.isRequired,
  menuCloseIcon: _propTypes2.default.string.isRequired,
  logo: _propTypes2.default.string.isRequired,
  iconLinks: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  links: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = (0, _reactRouterDom.withRouter)(SiteNavContainer);

/***/ }),

/***/ "rkxl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterDom = __webpack_require__("F8kA");

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadiumLink = (0, _radium2.default)(_reactRouterDom.Link);

exports.default = RadiumLink;

/***/ }),

/***/ "tQID":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiLineText = function MultiLineText(_ref) {
  var text = _ref.text,
      style = _ref.style,
      firstStyle = _ref.firstStyle,
      lastStyle = _ref.lastStyle,
      containerStyle = _ref.containerStyle;

  var i = 0;
  var paragraphs = text.split(/\r?\n/);

  return _react2.default.createElement(
    'div',
    { style: containerStyle },
    paragraphs.map(function (p) {
      i += 1;
      var pStyle = style;

      if (i === 1) {
        pStyle = _extends({}, pStyle, firstStyle);
      }

      if (i === paragraphs.length) {
        pStyle = _extends({}, pStyle, lastStyle);
      }

      return _react2.default.createElement(
        'p',
        { key: i, style: pStyle },
        p
      );
    })
  );
};

MultiLineText.propTypes = {
  text: _propTypes2.default.string.isRequired,
  // eslint-disable-next-line
  style: _propTypes2.default.object,
  // eslint-disable-next-line
  firstStyle: _propTypes2.default.object,
  // eslint-disable-next-line
  lastStyle: _propTypes2.default.object,
  // eslint-disable-next-line
  containerStyle: _propTypes2.default.object
};

MultiLineText.defaultProps = {
  style: {},
  firstStyle: {},
  lastStyle: {},
  containerStyle: {}
};

exports.default = MultiLineText;

/***/ }),

/***/ "y62H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GREY_LIGHT = exports.GREY_LIGHT = '#f3f3f3';
var GREY_LIGHT_HIGHLIGHT = exports.GREY_LIGHT_HIGHLIGHT = '#e6e6e6';
var WHITE = exports.WHITE = 'white';
var BLACK = exports.BLACK = 'black';
var TURQOISE = exports.TURQOISE = '#007cbb';
var TURQOISE_HIGHLIGHT = exports.TURQOISE_HIGHLIGHT = '#025986';

/***/ }),

/***/ "y6Z8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  window.initialRender = true;
  var now = Math.floor(Date.now());
  var loadingEl = document.getElementById('loading');

  if (window.noLoading) {
    loadingEl.remove();
  } else {
    var loadingTime = now - window.startTime;

    // Otherwise looks like flash of content
    var minimumLoadTime = 1000;
    var additionalLoadTime = minimumLoadTime - loadingTime;

    if (additionalLoadTime < 0) {
      additionalLoadTime = 0;
    }

    setTimeout(function () {
      loadingEl.classList.remove('loading');

      loadingEl.addEventListener('transitionend', function () {
        loadingEl.remove();
      }, true);
    }, additionalLoadTime);
  }
};

/***/ }),

/***/ "zf7l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (routes, url, fourOhFour) {
  var matchedRoute = void 0;

  if (routes) {
    routes.forEach(function (_ref) {
      var route = _ref.route,
          template = _ref.template,
          entryField = _ref.entryField,
          contentType = _ref.contentType;

      if (matchedRoute) {
        return;
      }

      if ((0, _routeHasVar2.default)(route)) {
        var regex = (0, _replaceRouteVar2.default)(route, '(.+)');
        var re = new RegExp(regex, 'i');
        var matches = url.match(re);

        if (matches && matches[1]) {
          matchedRoute = {
            template: template,
            entryField: entryField,
            contentType: contentType,
            match: matches[1]
          };
        }
      } else if (route === url) {
        matchedRoute = { template: template };
      } else if (route === '*') {
        matchedRoute = { template: template };
      }
    });
  }

  if (matchedRoute) {
    return matchedRoute;
  }

  if (fourOhFour) {
    return { template: fourOhFour };
  }

  return null;
};

var _routeHasVar = __webpack_require__("MKU2");

var _routeHasVar2 = _interopRequireDefault(_routeHasVar);

var _replaceRouteVar = __webpack_require__("qSi4");

var _replaceRouteVar2 = _interopRequireDefault(_replaceRouteVar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

},["jYr2"]);


// WEBPACK FOOTER //
// cd4b3bb1c7ac1e1c8ff4.main.js